<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordocas/svgCas9bg.svg" />
    <img id="bees" class="pageElement bouncingItem" src="/pages/img/sordocas/svgCas9Bees.svg" />

    <p id="text01" class="textBase pageElement">
      Cuando el hermano menor estaba a punto de largarse a llorar, llegó la
      reina de las abejas que él había salvado del fuego. La reina de las abejas
      voló junto a la boca de cada princesa y les sintió el aliento. Sin demora,
      descubrió a la princesa que había comido miel y se posó sobre sus labios.
      El hermano menor vio a la abeja y besó a Catalina.<br /><br />
      En un solo instante se deshizo el encantamiento. Los que eran de piedra
      recuperaron la vida mientras las tres hermanas y sus padres se despertaban
      llenos de alegría.<br /><br />
      El hermano menor se casó con la más joven de las princesas. Los hermanos
      se casaron con las otras dos hermanas. Y el padre de los principes vino a
      la boda y se reencontró con sus tres hijos varones.
    </p>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 22px;
  top: 464px;
}
#bees {
  position: absolute;
  left: 385px;
  top: 478px;
}
#text01 {
  position: absolute;
  width: 930px;
  left: 41px;
  top: 26px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 15a.mp4", "cas/Video 15b.mp4", "cas/Video 17.mp4",],
    }
  }
}
</script>